import React from "react";
import { LazyComponent } from "seed/helpers";

const Content = ({
  components,
  currentView,
  views,
  flow,
  viewParams,
  search,
  pathname,
  collapsedViews,
  toggleCollapse
}) => {

  if (!currentView?.name) return null;

  if (components && currentView.name in components) {

    const Component = components[currentView.name].component;
    if (!Component) return null;
    const props = {
      ...components[currentView.name].props,
      currentView,
      components,
      views,
      flow,
      viewParams,
      search,
      pathname,
      collapsedViews,
      toggleCollapse,
    };
    const isLazy = components[currentView.name].isLazy;

    return isLazy ?
      <LazyComponent {...props} component={Component} /> :
      <Component {...props} />;

  }

  return null;

}

export default Content;
